import { render, staticRenderFns } from "./StatsPriceIndicationsHeatmap.vue?vue&type=template&id=10dd71f4"
import script from "./StatsPriceIndicationsHeatmap.vue?vue&type=script&lang=js"
export * from "./StatsPriceIndicationsHeatmap.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports